/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { forwardRef } from "react";

const UserRoleSelect = forwardRef((props, ref) => {
  const { value, onChange, className } = props;

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth className={className}>
      <InputLabel id="select-label">Role</InputLabel>
      <Select
        labelId="select-role"
        id="role"
        value={value}
        label="Role"
        onChange={handleChange}
        ref={ref}
        classes={{ select: "flex items-center space-x-12" }}
        defaultValue="reviewer"
        size="small"
        required
      >
        <MenuItem value="admin" className="space-x-12">
          Administrator
        </MenuItem>
        <MenuItem value="manager" className="space-x-12">
          Manager
        </MenuItem>
        <MenuItem value="leadEditor" className="space-x-12">
          Lead Editor
        </MenuItem>
        <MenuItem value="editor" className="space-x-12">
          Editor
        </MenuItem>
        <MenuItem value="internalReviewer" className="space-x-12">
          Internal Reviewer
        </MenuItem>
        <MenuItem value="leadReviewer" className="space-x-12">
          Lead Reviewer
        </MenuItem>
        <MenuItem value="reviewer" className="space-x-12">
          Reviewer
        </MenuItem>
      </Select>
    </FormControl>
  );
});

export default UserRoleSelect;
